(function () {
  /* JCI: Delegate the fold-link action so it survives Shopify editor section reloads. */
  function handleFoldLinkClick(event) {
    var eventTarget = event.target;
    var foldLink = eventTarget && eventTarget.closest
      ? eventTarget.closest('.jci-waggle-landing-hero__cta')
      : null;

    if (!foldLink) return;

    var linkUrl;

    try {
      linkUrl = new URL(foldLink.href, window.location.href);
    } catch (error) {
      return;
    }

    var targetId = linkUrl.hash ? decodeURIComponent(linkUrl.hash.slice(1)) : '';
    var target = targetId ? document.getElementById(targetId) : null;

    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  }

  if (!window.jciWaggleHeroScrollHandlerReady) {
    window.jciWaggleHeroScrollHandlerReady = true;
    document.addEventListener('click', handleFoldLinkClick, true);
  }

  /* JCI: Re-apply the utm_content ad-variant copy after a Shopify editor section reload.
     The implementation lives in the section's inline snippet so it can run before first paint;
     this is only the lifecycle hook. It is a no-op when there is no recognised utm_content. */
  function applyHeroVariant(hero) {
    if (window.JciWaggleHeroVariant) window.JciWaggleHeroVariant.apply(hero);
  }

  function initializeHero(hero) {
    applyHeroVariant(hero);

    if (!hero || hero.dataset.heroControlsReady === 'true') return;

    var video = hero.querySelector('.jci-waggle-landing-hero__media video');
    var toggle = hero.querySelector('.jci-waggle-landing-hero__sound-toggle');

    hero.dataset.heroControlsReady = 'true';

    if (!video || !toggle) return;

    video.muted = true;

    function updateSoundControl() {
      var isMuted = video.muted || video.volume === 0;

      toggle.dataset.muted = isMuted ? 'true' : 'false';
      toggle.setAttribute('aria-pressed', isMuted ? 'false' : 'true');
      toggle.setAttribute('aria-label', isMuted ? 'Turn video sound on' : 'Mute video');
    }

    toggle.addEventListener('click', function () {
      var shouldUnmute = video.muted || video.volume === 0;

      if (shouldUnmute) {
        video.volume = 1;
        video.muted = false;

        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            video.muted = true;
            updateSoundControl();
          });
        }
      } else {
        video.muted = true;
      }

      updateSoundControl();
    });

    video.addEventListener('volumechange', updateSoundControl);
    updateSoundControl();
  }

  function initializeAllHeroes(root) {
    var scope = root || document;

    if (scope.matches && scope.matches('.jci-waggle-landing-hero')) {
      initializeHero(scope);
    }

    scope.querySelectorAll('.jci-waggle-landing-hero').forEach(initializeHero);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeAllHeroes(document);
    });
  } else {
    initializeAllHeroes(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeAllHeroes(event.target);
  });
})();
